export default "__VITE_ASSET__M4UN$A2J__"